import Login from '../components/Login'
import React from 'react'

const LoginPage = () => {
  return (
    <div>
      <Login/>
    </div>
  )
}

export default LoginPage
